import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const HighDetailedFollowers = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 50 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <g filter="url(#filter0_di_2305_75596)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23 20.8601C35.7985 20.8601 40.5 28.1926 40.5 34.0547C40.5 39.9167 27.005 40.865 23 40.865V40.8645C18.995 40.8645 5.5 39.9163 5.5 34.0542C5.5 28.1921 10.2015 20.9283 23 20.9283V20.8601Z"
            fill="url(#paint0_linear_2305_75596)"
          />
        </g>
        <g filter="url(#filter1_di_2305_75596)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.9995 4.1062C16.6202 4.1062 13.4305 9.01999 13.4305 12.9855C13.4305 18.5025 17.6542 23.6283 22.9987 23.6288C22.9992 23.6447 22.9995 23.6602 22.9995 23.6752C28.3443 23.6752 32.5684 18.5028 32.5684 12.9855C32.5684 9.01999 29.3788 4.1062 22.9995 4.1062Z"
            fill="url(#paint1_radial_2305_75596)"
          />
        </g>
        <g filter="url(#filter2_d_2305_75596)">
          <rect x="26.5" y="26.5" width="20" height="20" rx="10" fill="url(#paint2_linear_2305_75596)" />
          <g filter="url(#filter3_d_2305_75596)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.6364 30.8552C36.0228 30.8552 35.5253 31.3527 35.5253 31.9663V35.2186H31.9894C31.3758 35.2186 30.8783 35.7161 30.8783 36.3297C30.8783 36.9434 31.3758 37.4408 31.9894 37.4408H35.5253V41.0337C35.5253 41.6474 36.0228 42.1448 36.6364 42.1448C37.2501 42.1448 37.7476 41.6474 37.7476 41.0337V37.4408H41.0568C41.6704 37.4408 42.1679 36.9434 42.1679 36.3297C42.1679 35.7161 41.6704 35.2186 41.0568 35.2186H37.7476V31.9663C37.7476 31.3527 37.2501 30.8552 36.6364 30.8552Z"
              fill="white"
              fillOpacity="0.8"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_di_2305_75596"
            x="2.5"
            y="20.8601"
            width="41"
            height="27.0049"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2305_75596" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2305_75596" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="0.5" dy="0.5" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_2305_75596" />
          </filter>
          <filter
            id="filter1_di_2305_75596"
            x="10.4305"
            y="4.1062"
            width="25.1379"
            height="26.5688"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2305_75596" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2305_75596" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="0.5" dy="0.5" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="shape" result="effect2_innerShadow_2305_75596" />
          </filter>
          <filter
            id="filter2_d_2305_75596"
            x="23.5"
            y="25.5"
            width="26"
            height="26"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2305_75596" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2305_75596" result="shape" />
          </filter>
          <filter
            id="filter3_d_2305_75596"
            x="28.8783"
            y="29.8552"
            width="15.2896"
            height="15.2896"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2305_75596" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2305_75596" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear_2305_75596"
            x1="23"
            y1="25.6804"
            x2="23"
            y2="40.865"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DF6D02" />
            <stop offset="1" stopColor="#EDB13A" />
          </linearGradient>
          <radialGradient
            id="paint1_radial_2305_75596"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(19.4021 9.51847) rotate(51.1466) scale(14.6267 14.3045)"
          >
            <stop stopColor="#9F6D43" />
            <stop offset="1" stopColor="#561300" />
          </radialGradient>
          <linearGradient
            id="paint2_linear_2305_75596"
            x1="36.5"
            y1="26.5"
            x2="36.5"
            y2="46.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#18D6B3" />
            <stop offset="1" stopColor="#039400" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default HighDetailedFollowers
